import React from 'react';

const MarqueeSection = () => {
    const logos = ["Vertex", "Nova", "Cipher", "Bolt", "Nexus", "Sphere", "Orbit", "Flux"];
    return (
        <section className="py-20 border-y border-gray-800/50 bg-cyber-black/50 backdrop-blur-sm relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-cyber-black via-transparent to-cyber-black z-10 pointer-events-none" />

            <div className="max-w-7xl mx-auto px-4 mb-10 text-center relative z-20">
                <p className="text-sm font-bold text-neon-blue uppercase tracking-[0.3em] font-orbitron drop-shadow-[0_0_8px_rgba(0,243,255,0.5)]">
                    Trusted by industry leaders
                </p>
            </div>

            <div className="relative flex overflow-x-hidden group">
                <div className="animate-marquee whitespace-nowrap flex space-x-32 items-center">
                    {[...logos, ...logos, ...logos, ...logos].map((logo, idx) => (
                        <span
                            key={idx}
                            className="text-6xl md:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-b from-gray-700 to-gray-900 transition-all duration-500 cursor-default select-none tracking-tighter hover:from-white hover:to-gray-400 hover:drop-shadow-[0_0_15px_rgba(255,255,255,0.3)] font-orbitron opacity-70 hover:opacity-100"
                        >
                            {logo}
                        </span>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default MarqueeSection;
